// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1hWjL","label":"LabeledBox_label__2S58v"};